import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    input,
} from '@angular/core';
import { ITab } from '@dxp/core/models';
import { TelXLButtonComponent } from '../button/button.component';

@Component({
    selector: 'telxl-tab',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TelXLButtonComponent],
    templateUrl: './tab.component.html',
    styleUrl: './tab.component.scss',
})
export class TelXLTabComponent {
    // alignment of the entire block (“left” / “centered”)
    alignment = input<'left' | 'centered'>('centered');
    // extra wrapper classes
    containerClass = input<string>('');
    // flex justify on the UL
    justifyContentClass = input<string>('justify-content-end');

    tabFlex = input<number>(1);
    tabTextAlign = input<'left' | 'center' | 'center' | 'right'>('center');
    transitionDuration = input<string>('0.8s');
    transitionTiming = input<string>('ease');
    tabPaddingX = input<string>('.5rem');
    tabPaddingY = input<string>('0.8rem');
    centeredPaddingX = input<string>('0rem');
    singleTabWidth = input<string>('33%');
    disabledOpacity = input<number>(0.5);
    activeColor = input<string>('#000');
    inactiveColor = input<string>('#adb5bd');
    showUnderline = input<boolean>(true);
    tabBorderWidth = input<string>('3px');
    tabBorderColor = input<string>('#000');
    hoverOpacity = input<string>('0.7');
    variant = input<'tab' | 'pill'>('tab');

    @Input({ required: true }) tabs!: ITab[];
    @Input({ required: true }) selected!: string;
    @Output() selectedChange = new EventEmitter<string>();

    isSelected = (tab: ITab) => this.selected === tab.index;

    handleKeyPress(event: KeyboardEvent, tab: ITab) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.setSelected(tab);
        }
    }

    setSelected(tab: ITab) {
        if (!tab.disabled) {
            this.selectedChange.emit(tab.index);
        }
    }
}
